import { setSettings } from '@fantastic-admin/settings'

export default setSettings({
  app: {
    routeMode: 'html5',
    home: {
      enable: true,
      title: '控制台',
      fullPath: '/console',
    },
  },
  menu: {
    mainMenuClickMode: 'jump',
  },
  toolbar: {
    fullscreen: true,
    pageReload: true,
    colorScheme: true,
  },
})
